export default {
  "mb_1_3_0": {
    "productNameMustBeInAtLeastOneLanguage": "商品名称至少填写一种语言",
    "finish": "完成"
  }
}